// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2y5g4","primaryHeading":"Header_primaryHeading__17JMt"};